import {Icon, Typography} from '@sollapay/ui/components';

import type {FC} from 'react';

export interface OverageNoteProps {
  lead: string;
  rest: string;
}

export const OverageNote: FC<OverageNoteProps> = ({lead, rest}) => (
  <div data-slot="overage-note" role="status" className="flex items-center gap-1.5">
    <Icon
      name="bell-ringing-01"
      width={16}
      height={16}
      aria-hidden="true"
      className="shrink-0 text-indication-warning"
    />
    <Typography size="sm" className="text-indication-warning">
      <span className="font-semibold">{lead}</span> {rest}
    </Typography>
  </div>
);
